
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'lib-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class LoginComponent {}
